import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=877fd758&scoped=true&"
import script from "./Compass.vue?vue&type=script&lang=ts&"
export * from "./Compass.vue?vue&type=script&lang=ts&"
import style0 from "./Compass.vue?vue&type=style&index=0&id=877fd758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877fd758",
  null
  
)

export default component.exports